import queryString from 'query-string';

import { PaymentResultQueryParams } from '../../constants/pathQueryParams';
import {
  SOLUTION_TYPE,
  SolutionType,
} from '../../../shared/constants/user-info/solutionType';
export const generatePaymentResultUrl = (
  solutionType: SolutionType,
  params: Partial<Record<PaymentResultQueryParams, string>>,
) => {
  const queryParams = queryString.stringify(params, {
    skipNull: true,
    skipEmptyString: true,
  });

  switch (solutionType) {
    case SOLUTION_TYPE.SCAN_IQ:
      return getUrl('scaniq-payment-result', queryParams);
    case SOLUTION_TYPE.CHALLENGE:
      return getUrl('challenge-payment-result', queryParams);
    default:
      return getUrl('payment-result', queryParams);
  }
};

const getUrl = (basePath: string, queryParams: string) =>
  `${window.location.protocol}//${window.location.host}/#!/${basePath}?${queryParams}`;
